export default function StatusBadge({ status, compact = false }) {
  const map = {
    EERLIJK: { cls: "oc-status-fair", label: compact ? "Eerlijk" : "Eerlijk" },
    HOOG: { cls: "oc-status-high", label: compact ? "Hoog" : "Aan de hoge kant" },
    OVERDREVEN: { cls: "oc-status-excessive", label: compact ? "Hoog!" : "Overdreven" },
  };
  const conf = map[status] || { cls: "oc-status-fair", label: status };
  return (
    <span
      data-testid={`status-${(status || "").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 ${compact ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-[12px]"} rounded-md font-semibold uppercase tracking-[0.04em] whitespace-nowrap ${conf.cls}`}
    >
      <span className={`${compact ? "w-1 h-1" : "w-1.5 h-1.5"} rounded-full bg-current`} />
      {conf.label}
    </span>
  );
}
